import styled from 'styled-components';

const StyledInput = styled.input.attrs({
	type: 'checkbox',
	name: 'prop',
})`
	margin: 0;
	width: 16px;
	height: 16px;
`;

export { StyledInput as ContentInputFlag };
